/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Contract, ContractFactory, testMethod, callMethod, multicallMethods, fetchContractState, ContractInstance, signExecuteMethod, addStdIdToFields, encodeContractFields, } from "@alephium/web3";
import { default as TokenBridgeForChainContractJson } from "../token_bridge/TokenBridgeForChain.ral.json";
import { getContractByCodeHash } from "./contracts";
class Factory extends ContractFactory {
    constructor() {
        super(...arguments);
        this.consts = {
            Path: {
                AttestTokenHandler: "00",
                TokenBridgeForChain: "01",
                TokenPool: "02",
            },
            ErrorCodes: {
                InvalidEmitChainId: BigInt("0"),
                InvalidEmitAddress: BigInt("1"),
                InvalidMessageSize: BigInt("2"),
                InvalidSequence: BigInt("3"),
                InvalidModule: BigInt("4"),
                InvalidActionId: BigInt("5"),
                InvalidVersion: BigInt("6"),
                InvalidGuardianSetIndex: BigInt("7"),
                InvalidGuardianSetSize: BigInt("8"),
                InvalidSignatureSize: BigInt("9"),
                InvalidSignatureGuardianIndex: BigInt("10"),
                InvalidSignature: BigInt("11"),
                GuardianSetExpired: BigInt("12"),
                InvalidTargetChainId: BigInt("13"),
                ContractStateMismatch: BigInt("14"),
                InvalidRegisterChainMessage: BigInt("15"),
                InvalidTokenId: BigInt("16"),
                InvalidNonceSize: BigInt("17"),
                TokenNotExist: BigInt("18"),
                InvalidTransferTargetChain: BigInt("19"),
                InvalidDestroyUnexecutedSequenceMessage: BigInt("20"),
                InvalidCaller: BigInt("21"),
                ArbiterFeeLessThanAmount: BigInt("22"),
                InvalidAttestTokenMessage: BigInt("23"),
                InvalidPayloadId: BigInt("24"),
                InvalidTransferMessage: BigInt("25"),
                ExpectRemoteToken: BigInt("26"),
                InvalidConsistencyLevel: BigInt("27"),
                InvalidUpdateRefundAddressMessage: BigInt("28"),
                TransferAmountLessThanMessageFee: BigInt("29"),
                InvalidAttestTokenArg: BigInt("30"),
                InvalidAttestTokenHandler: BigInt("31"),
                NotSupported: BigInt("32"),
            },
            PayloadId: { Transfer: "01", AttestToken: "02" },
        };
        this.tests = {
            setExecuted: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "setExecuted", params, getContractByCodeHash);
            }),
            compact: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "compact", params, getContractByCodeHash);
            }),
            checkSequenceInSubContract: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "checkSequenceInSubContract", params, getContractByCodeHash);
            }),
            checkSequence: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "checkSequence", params, getContractByCodeHash);
            }),
            nextSendSequence: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "nextSendSequence", params, getContractByCodeHash);
            }),
            checkCompleteTransfer: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "checkCompleteTransfer", params, getContractByCodeHash);
            }),
            parseCompleteTransfer: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "parseCompleteTransfer", params, getContractByCodeHash);
            }),
            completeTransfer: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "completeTransfer", params, getContractByCodeHash);
            }),
            destroyUnexecutedSequenceContracts: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "destroyUnexecutedSequenceContracts", params, getContractByCodeHash);
            }),
            deposit: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "deposit", params, getContractByCodeHash);
            }),
            withdraw: (params) => __awaiter(this, void 0, void 0, function* () {
                return testMethod(this, "withdraw", params, getContractByCodeHash);
            }),
        };
    }
    encodeFields(fields) {
        return encodeContractFields(addStdIdToFields(this.contract, fields), this.contract.fieldsSig, []);
    }
    at(address) {
        return new TokenBridgeForChainInstance(address);
    }
}
// Use this object to test and deploy the contract
export const TokenBridgeForChain = new Factory(Contract.fromJson(TokenBridgeForChainContractJson, "", "58443a1005d6791f07d0701f4ef91ec367777ab67be27990a6b8fcb7c84e7240", []));
// Use this class to interact with the blockchain
export class TokenBridgeForChainInstance extends ContractInstance {
    constructor(address) {
        super(address);
        this.view = {
            nextSendSequence: (params) => __awaiter(this, void 0, void 0, function* () {
                return callMethod(TokenBridgeForChain, this, "nextSendSequence", params === undefined ? {} : params, getContractByCodeHash);
            }),
            completeTransfer: (params) => __awaiter(this, void 0, void 0, function* () {
                return callMethod(TokenBridgeForChain, this, "completeTransfer", params, getContractByCodeHash);
            }),
            destroyUnexecutedSequenceContracts: (params) => __awaiter(this, void 0, void 0, function* () {
                return callMethod(TokenBridgeForChain, this, "destroyUnexecutedSequenceContracts", params, getContractByCodeHash);
            }),
            deposit: (params) => __awaiter(this, void 0, void 0, function* () {
                return callMethod(TokenBridgeForChain, this, "deposit", params, getContractByCodeHash);
            }),
            withdraw: (params) => __awaiter(this, void 0, void 0, function* () {
                return callMethod(TokenBridgeForChain, this, "withdraw", params, getContractByCodeHash);
            }),
        };
        this.transact = {
            nextSendSequence: (params) => __awaiter(this, void 0, void 0, function* () {
                return signExecuteMethod(TokenBridgeForChain, this, "nextSendSequence", params);
            }),
            completeTransfer: (params) => __awaiter(this, void 0, void 0, function* () {
                return signExecuteMethod(TokenBridgeForChain, this, "completeTransfer", params);
            }),
            destroyUnexecutedSequenceContracts: (params) => __awaiter(this, void 0, void 0, function* () {
                return signExecuteMethod(TokenBridgeForChain, this, "destroyUnexecutedSequenceContracts", params);
            }),
            deposit: (params) => __awaiter(this, void 0, void 0, function* () {
                return signExecuteMethod(TokenBridgeForChain, this, "deposit", params);
            }),
            withdraw: (params) => __awaiter(this, void 0, void 0, function* () {
                return signExecuteMethod(TokenBridgeForChain, this, "withdraw", params);
            }),
        };
    }
    fetchState() {
        return __awaiter(this, void 0, void 0, function* () {
            return fetchContractState(TokenBridgeForChain, this);
        });
    }
    multicall(...callss) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield multicallMethods(TokenBridgeForChain, this, callss, getContractByCodeHash));
        });
    }
}
